export const curatedBoxWarningModalConfig = {
  modalHeaderText: 'Are you sure?',
  modalTitleText: `This will cancel the recipes you've already chosen.`,
  modalBodyText: `Instead, you'll get a selection of curated recipes.`,
  modalPrimaryButtonText: 'Yes, give me a selection',
  modalSecondaryButtonText: 'No, keep my recipes',
}
